export const TABS = {
  SUMMARY: 'SUMMARY',
  DIAGNOSIS: 'DIAGNOSIS',
  ENCOUNTERS: 'ENCOUNTERS',
}
